import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postRecallAPI = createApi(`RecallSlice`,"POST");

const RecallSlice = createSlice({
  name: 'RecallSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRecallAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRecallAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRecallAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RecallSlice.reducer;